<template>
  <v-dialog v-model="dialog" persistent max-width="450">
    <v-card>
      <v-card-title class="headline">{{label}}</v-card-title>
      <v-card-text style="font-size:19px" v-html="body" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="handleSubmit(false)">{{cancelText}}</v-btn>
        <v-btn color="primary" @click="handleSubmit(true)">{{confirmText}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import UpdateCheckerMixin from "./UpdateCheckerMixin";
export default {
  props: {
    label: {
      type: String,
      default: "Внимание",
    },
    body: {
      type: String,
      default: `Доступна новая версия Формы регистрации. Обновить?
        <br />Нажмите "Обновить", чтобы перезагрузить страницу. Все введённые данные при этом будут утеряны.`,
    },
    cancelText: {
      type: String,
      default: "Отмена",
    },
    confirmText: {
      type: String,
      default: "Обновить",
    },
  },
  mixins: [UpdateCheckerMixin],
};
</script>